import { clientOnlyLazy } from 'components/ClientOnlySuspense/clientOnlyLazy';
import LoadingModal from 'modals/LoadingModal';

export const DeferQueueItemModalContainerLoadable = clientOnlyLazy({
  loader: () =>
    import(
      /* webpackChunkName: "DeferQueueItemModalContainer" */
      './DeferQueueItemModalContainer'
    ),
  loading: LoadingModal,
});
